import classnames from 'classnames'
import { PersonalDetailsForm } from 'shared/components/PersonalDetailsForm'

import guestBookingStyles from 'booking/components/GuestCheckoutComponents/styles.module.scss'
import styles from 'subscription-flow/brazil/components/styles.module.scss'

//TODO There are some boleto named variables, which might be depraceted / left from old code. Review and refactor them
const PersonalDetails = ({ formData, onChangeFormData, personalDataFormRef, showSubmitErrors }) => {
    const [isUsingBoleto, setIsUsingBoleto] = React.useState(false)
    const boletoClassName = classnames(styles.boleto, guestBookingStyles.personalDetailsFormContainer, {
        [styles.selected]: isUsingBoleto,
    })

    return (
        <div className={'mt-5'}>
            <h3 className="font-weight-bold text-uppercase mb-4">
                <T>guest.booking.review.pay.personal.details.label</T>
            </h3>
            <div className={boletoClassName} onClick={setIsUsingBoleto}>
                <PersonalDetailsForm
                    formData={formData}
                    onChangeFormData={onChangeFormData}
                    personalDataFormRef={personalDataFormRef}
                    showSubmitErrors={showSubmitErrors}
                />
            </div>
        </div>
    )
}

export default PersonalDetails
